import React, { Component, Fragment } from "react";

const Title = (props) => {
    return (
        <div className="form-row">
            <div className="col-md-12 mb-3" style={{ textAlign: "center",fontSize:"50px" }}>
                <h6>{props.name}</h6>
            </div>
        </div>
    )
}

export default Title;